import styled, { css } from 'styled-components'
import { colors } from '../../styles/vars/colors.style'
import { mq } from '../../styles/vars/media-queries.style'
import { Heading4 } from '../../styles/vars/textStyles.style'
import { easings } from '../../styles/vars/easings.style'
import { clamp } from '../../styles/utils/conversion.style'
import { breakpoints } from '../../styles/vars/breakpoints.style'

export const ItineraryItem = styled.li`
  padding-bottom: 3rem;
  position: relative;

  ${Heading4} {
    display: inline-block;
    position: relative;
  }

  :not(:first-of-type) {
    padding-top: 3rem;
  }
`

export const ItineraryItemLine = styled.span`
  background-color: ${colors.darkBlue};
  bottom: 0;
  height: 0.1rem;
  left: 0;
  position: absolute;
  right: 0;
  transform-origin: 0% 0%;
`

const ItineraryIconsShared = css`
  position: absolute;
  ${clamp('top', 2, 6, breakpoints.tabletP, breakpoints.contained)};
  right: 0;
  ${clamp('width', 22, 38, breakpoints.mobile, breakpoints.contained)};
  ${clamp('height', 22, 38, breakpoints.mobile, breakpoints.contained)};
  border-radius: 50%;

  ${mq.tabletP} {
    position: relative;
    right: auto;
    display: inline-block;
    margin-left: 1rem;
  }
`

export const ItineraryLink = styled.a`
  ${ItineraryIconsShared}
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border: 0.1rem solid ${colors.darkBlue};
  opacity: 0.5;

  svg {
    position: absolute;
    top: 50%;
    left: 50%;
    height: 0.9rem;
    width: 0.2rem;

    ${mq.tabletL} {
      width: 0.2rem;
      height: 1.3rem;
    }

    :nth-child(1) {
      transform: translateX(-50%) translateY(-50%);
      opacity: 1;
      transition: all 0.4s ${easings.out.quart} 0.25s;
    }

    :nth-child(2) {
      transform: translateX(900%) translateY(-50%);
      opacity: 0;
      transition: all 0.4s ${easings.in.quart};
    }
  }

  :hover {
    svg {
      :nth-child(1) {
        transform: translateX(-900%) translateY(-50%);
        opacity: 0;
        transition: all 0.4s ${easings.in.quart};
      }

      :nth-child(2) {
        transform: translateX(-50%) translateY(-50%);
        opacity: 1;
        transition: all 0.4s ${easings.out.quart} 0.25s;
      }
    }
  }
`

export const ItineraryBadge = styled.span`
  ${ItineraryIconsShared}
  background-image: url('${props => props.bg}');
  background-position: 50% 50%;
  background-repeat: no-repeat;
  background-size: contain;
  display: none;
`

export const ItineraryImage = styled.div`
  // border-radius: 0.6rem;
  ${clamp('height', 45, 109, breakpoints.mobile, breakpoints.contained, true)};
  overflow: hidden;
  ${clamp('width', 65, 154, breakpoints.mobile, breakpoints.contained, true)};

  img {
    height: 100%;
    object-fit: cover;
    width: 100%;
  }
`

export const ItineraryIcon = styled.span`
  display: block;
  text-align: center;
  ${clamp('width', 65, 154, breakpoints.mobile, breakpoints.contained, true)};

  img {
    margin: 0 auto;
  }
`

export const ItineraryDetails = styled.div`
  position: relative;

  ${mq.tabletL} {
    align-content: center;
    align-items: center;
    display: flex;
    flex-direction: row;
    height: 100%;
    justify-content: space-between;
  }
`

export const ItineraryLocation = styled.div`
  ${mq.tabletL} {
    padding-left: 1rem;
    width: 50%;
  }

  ${mq.desk} {
    width: 60%;
  }

  ${mq.deskL} {
    width: 70%;
  }

  ${Heading4} {
    min-width: 100%;
    padding-right: 3rem;

    ${mq.tabletP} {
      padding-right: 0;
    }
  }
`

export const DescOuter = styled.div`
  padding-bottom: 4rem;
`

export const ItineraryDate = styled.div`
  ${mq.tabletL} {
    text-align: right;
    width: 50%;
  }

  ${mq.desk} {
    width: 40%;
  }
`
